import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { MockupSection } from './components/MockupSection';
import { PainSection } from './components/PainSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ProductSection } from './components/ProductSection';
import { SocialProof } from './components/SocialProof';
import { BonusSection } from './components/BonusSection';
import { FaqSection } from './components/FaqSection';
import { DoubleClose } from './components/DoubleClose';
import { Footer } from './components/Footer';
export function App() {
  useEffect(() => {
    document.title = 'Ebook Jump Box';
    const w = window as any;
    if (!w.fbq) {
      const n: any = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      w.fbq = n;
      w._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [];
    }
    const existingScript = document.querySelector('script[src*="fbevents.js"]');
    if (!existingScript) {
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
    }
    if (!document.querySelector('img[src*="facebook.com/tr"]')) {
      const noscriptImg = document.createElement('img');
      noscriptImg.height = 1;
      noscriptImg.width = 1;
      noscriptImg.style.display = 'none';
      noscriptImg.src = 'https://www.facebook.com/tr?id=2802498006808075&ev=PageView&noscript=1';
      document.body.appendChild(noscriptImg);
    }
    w.fbq('init', '2802498006808075');
    w.fbq('track', 'PageView');
    w.fbq('track', 'ViewContent', {
      content_name: 'Ebook Pies de Acero',
      content_type: 'product',
      value: 19900,
      currency: 'ARS'
    });
  }, []);
  return <div className="min-h-screen bg-dark text-gray-300 font-sans selection:bg-neon selection:text-black" data-id="element-0">
      <main data-id="element-1">
        <HeroSection data-id="element-2" />
        <MockupSection data-id="element-3" />
        <PainSection data-id="element-4" />
        <BenefitsSection data-id="element-5" />
        <ProductSection data-id="element-6" />
        <SocialProof data-id="element-7" />
        <BonusSection data-id="element-8" />
        <FaqSection data-id="element-9" />
        <DoubleClose data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}